import Skeleton from "react-loading-skeleton";
import { formatAddress } from "../../Layout/Common/common";
import { addressLine1Keys, addressToKeys, contactLineKeys } from "../../constants";

export const ShippingAddress = ({ shipAddress }) => {
  return (
    <div className="col-sm-6 col-md-12 col-lg-6">
      <div className="placed-order-details">
        <div className="cc-placed-order">
          <p>Shipping Address</p>
          <div className="placed-order-info placed-orderAddress" style={{ textTransform: "capitalize" }}>
            <address>
              {shipAddress ? formatAddress(shipAddress, addressToKeys).join(", ") : <Skeleton width={100} />}
              <br />
              {shipAddress ? formatAddress(shipAddress, addressLine1Keys).join(", ") : <Skeleton width={150} />}
              <br />
              {shipAddress ? shipAddress.shipCountry : <Skeleton width={150} />}
              <br />
              {shipAddress ? formatAddress(shipAddress, contactLineKeys).join(", ") : <Skeleton width={150} />}
            </address>
          </div>
        </div>
      </div>
    </div>
  );
};
